<template>
    <div class="create-box">
        <div class="create-box-title">
            <h3>添加节</h3>
        </div>
        <Form ref="addForm" :model="addForm" :rules="ruleValidate" label-position="left" :label-width="80">
            <FormItem label="小节名称" class="form-item" prop="name">
                <Input v-model="addForm.name" style="width: 300px" placeholder="请输入小节名称"></Input>
            </FormItem><br />
            <FormItem label="实训类型" class="form-item">
                <Select v-model="addForm.lab_type" style="width: 300px" @on-change="changeLabType">
                    <Option value="0">无</Option>
                    <Option value="1">Lab环境</Option>
                    <Option value="2">Link环境</Option>
                </Select>
            </FormItem>
<!--            <FormItem label="网盘类型" class="form-item">-->
<!--                <Select v-model="addForm.pan_type" style="width: 300px" @on-change="panChange">-->
<!--                    <Option value="1">公有网盘</Option>-->
<!--                    <Option value="2">私有网盘</Option>-->
<!--                </Select>-->
<!--            </FormItem>-->
<!--            <FormItem label="" class="form-item" v-if="addForm.pan_type== '2'">-->
<!--                <Select v-model="addForm.pan_name" style="width: 300px" >-->
<!--                    <Option :value="it.id" v-for="it in pri_wpans_info" :key="it.id" @click.native="panClick(it)">{{it.name}}</Option>-->
<!--                </Select>-->
<!--            </FormItem>-->
            <FormItem label="Lab环境" prop="image_id" v-if="addForm.lab_type == 1">
                <Button type="default" @click="selectContestEnv">{{imagesButtonName}}</Button>
            </FormItem>
            <FormItem label="数据集" v-if="addForm.lab_type == 1">
                <Tag closable v-for="item in TagList" :name="item.id" @on-close="closeTag">{{item.name}}</Tag>
                <br v-if="TagList !==undefined && TagList.length > 0" />
                <Button type="default" @click="selectDataSet">请选择数据集</Button>
            </FormItem>
<!--            <FormItem label="数据集">-->
<!--                <Tag closable v-for="item in TagList" :name="item.id" @on-close="closeTag">{{item.name}}</Tag>-->
<!--                <br v-if="TagList !==undefined && TagList.length > 0" />-->
<!--                <Button type="default" @click="selectDataSet">请选择数据集</Button>-->
<!--            </FormItem>-->

<!--            <FormItem label="Lab环境" class="form-item" v-show="addForm.lab_type == '1'">-->
<!--                <Select v-model="addForm.lab_ids" style="width:300px" multiple>-->
<!--                    <OptionGroup :label="item.platform.name"  v-for="item in lab_type_info" :key="item.platform.id">-->
<!--                        <Option :value="it.id" v-for="it in item.labs" :key="it.id" :title="it.remarks">-->
<!--                            {{it.img_type}}::{{it.img_version}}-->
<!--                        </Option>-->
<!--                    </OptionGroup>-->
<!--                </Select>-->
<!--            </FormItem>-->


            <FormItem label="Link环境" class="form-item" v-if="addForm.lab_type == '2'">
                <Input v-model="addForm.lab_link" style="width: 300px" type="url" placeholder="请输入Link环境url"></Input>
            </FormItem>
            <FormItem label="相关课件" class="form-item">
                <div class="courseware" v-for="(item,index) in addForm.data" :key="index">
                    <div class="courseware-top">
                        <Select v-model="item.data_type" style="width: 120px">
                            <Option value="1" v-if="addForm.lab_type != 0" >Markdown</Option>
                            <Option value="5" v-if="addForm.lab_type != 0">富文本编辑器</Option>
                            <Option value="2" v-if="addForm.lab_type == 0">视频</Option>
                            <Option value="3" v-if="addForm.lab_type == 0">课件</Option>
                            <Option value="4" v-if="addForm.lab_type == 0">外链</Option>
                        </Select>
                        <div v-if="item.data_type =='1'" >
                            <Input v-model="item.document"
                                   type="textarea"
                                   :rows="7"
                                   placeholder="请输入Markdown内容"
                                   style="width: 100%;margin-top: 15px" />
                        </div>
                        <div v-if="item.data_type == '5'" class="chapter-add">
                            <ckeditor :editor="editor" v-model="item.document" :config="editorConfig" style="height:300px; border: 1px solid #ccc;"></ckeditor>
                        </div>
                        <div style="display: inline-block" v-if="item.data_type =='2'">
                            <!-- <span style="margin: 0 10px">本地上传</span> -->
<!--                            <div v-show="addForm.pan_type == '1'" style="display: inline-block">-->
                                <!-- <Upload :action="baseUri+'api-course/tm/course/chapter/subsecdata_video?access_token='+access_token"
                                        style="display: inline-block"
                                        name="subsec_file"
                                        :data="{introduction:'简介',order:index}"
                                        :format="['mp4','MOV','avi']"
                                        accept=".mp4,.mov,.avi"
                                        :max-size="maxSize"
                                        :on-exceeded-size="uploadMaxSizeFunc"
                                        :on-format-error="videoFormatError"
                                        :on-error="videoErr"
                                        :on-success="videoSuccess"
                                >
                                    <Button icon="ios-cloud-upload-outline" @click="cur_subsecdata_idx=index">选择文件</Button>
                                </Upload> -->

                                <uploadComm
                                        :action="baseUri+'api-course/tm/course/chapter/subsecdata_video?access_token='+access_token"
                                        sstyle="display: inline-block"
                                        name="subsec_file"
                                        :data="{introduction:'简介',order:index}"
                                        :format="['mp4','MOV','avi']"
                                        accept=".mp4,.mov,.avi"
                                        :maxSize="maxSize"
                                        :onError="videoErr"
                                        :onSuccess="videoSuccess"
                                        :uploadFunc="currentIndexId"
                                        :indexx="index"
                                >
                                </uploadComm>

                                
<!--                            </div>-->
<!--                            <div v-show="addForm.pan_type == '2'" style="display: inline-block">-->
<!--                                <Upload :action="cwUploadUrl"-->
<!--                                        style="display: inline-block"-->
<!--                                        name="file"-->
<!--                                        :format="['mp4','MOV','avi']"-->
<!--                                        :on-format-error="cwFormatError"-->
<!--                                        :on-success="panVideoSuccess"-->
<!--                                        :on-error="cwErr"-->
<!--                                >-->
<!--                                    <Button icon="ios-cloud-upload-outline" @click="cur_subsecdata_idx=index">选择文件</Button>-->
<!--                                </Upload>-->
<!--                            </div>-->
                        </div>
                        <div style="display: inline-block" v-if="item.data_type =='3'">
                            <!-- <span style="margin: 0 10px">本地上传</span>
                                <Upload :action="baseUri+'api-course/tm/course/chapter/subsecdata_cw?access_token='+access_token"
                                        style="display: inline-block"
                                        name="subsec_file"
                                        :data="{introduction:'简介',order:index}"
                                        :format="['pdf']"
                                        :accept="pdf"
                                        :max-size="maxSize"
                                        :on-exceeded-size="uploadMaxSizeFunc"
                                        :on-format-error="cwFormatError"
                                        :on-success="cwSuccess"
                                        :on-error="cwErr"
                                >
                                    <Button icon="ios-cloud-upload-outline" @click="cur_subsecdata_idx=index">选择文件</Button>
                                </Upload>
                            &nbsp;<span style="color:red;">仅支持上传 pdf</span> -->
                            <uploadComm
                                        :action="baseUri+'api-course/tm/course/chapter/subsecdata_cw?access_token='+access_token"
                                        sstyle="display: inline-block"
                                        name="subsec_file"
                                        :data="{introduction:'简介',order:index}"
                                        :format="['pdf']"
                                        accept=".pdf"
                                        :maxSize="1024 * 50"
                                        :onError="cwErr"
                                        :onSuccess="cwSuccess"
                                        :uploadFunc="currentIndexId"
                                        :indexx="index"
                                >
                                </uploadComm>

<!--                            </div>-->
<!--                            <div v-show="addForm.pan_type == '2'" style="display: inline-block">-->
<!--                                <Upload :action="cwUploadUrl"-->
<!--                                        style="display: inline-block"-->
<!--                                        name="file"-->
<!--                                        :format="['pdf','ppt','pptx','word','txt','docx','doc','xls','xlsx']"-->
<!--                                        :on-format-error="cwFormatError"-->
<!--                                        :on-success="panCwSuccess"-->
<!--                                        :on-error="cwErr"-->
<!--                                >-->
<!--                                    <Button icon="ios-cloud-upload-outline" @click="cur_subsecdata_idx=index">选择文件</Button>-->
<!--                                </Upload>-->
<!--                            </div>-->
                        </div>
                        <div style="display: inline-block;width: 60%" v-if="item.data_type =='4'">
                            <Input v-model="item.link" placeholder="请输入url"></Input>
                        </div>
                        <Icon type="md-close" class="close" size="16" @click="_delete"/>
                    </div>
                    <div style="margin-top: 10px">
                        <Input v-model="item.introduction" v-if="item.data_type != '' " style="width:100%" placeholder="请输入附件标题"></Input>
                    </div>
                </div>
                <Button icon="ios-add" @click="addCourseware">添加附件</Button>
            </FormItem>
            <!-- <FormItem label="相关试题" class="form-item">
                <Button icon="ios-add" @click="selTestPaperModel=true">添加试卷</Button>
            </FormItem>
            <hr> -->
        </Form>
        <div class="btn-box">
            <Button type="primary" @click="confirm">确定</Button>
            <Button class="ml15" @click="cancel">取消</Button>
        </div>
        <!-- <Modal
                v-model="selTestPaperModel"
                title="选择试卷"
                :styles="{top: '10px'}"
                width="600">
            <div class="modal-box">
                <div class="list-item">
                    <span>所属专业</span>
                    <Select v-model="specialty" style="width: 200px"  placeholder="请选择专业">
                        <Option :value="item.id" v-for="(item,idx) in direction_info" :key="idx">{{item.name}}</Option>
                    </Select>
                </div>
                <div>
                    <Input search placeholder="试卷搜索" />
                    <div class="table-div">
                        <Table
                                :columns="columns"
                                :data="datas"
                                no-data-text="没有试卷可以选择，请前往【习题管理】中创建类型为“课后习题”的试卷。"
                                height="400"></Table>
                    </div>
                    <div style="margin-top: 20px">
                        不可选试卷为本课程已选试卷，如仍然想添加这类试卷，需要先去习题组卷中复制这类试卷。
                        类型为“独立试卷”的试卷不在此处显示，不能嵌入课程只能发布在习题广场。
                    </div>
                </div>
            </div>
        </Modal> -->

        <!-- Lab环境-->
        <Modal
                v-model="showEnv"
                title="选择竞赛环境"
                width="700"
        >
            <Tabs :value="currentImagesTabs" @on-click="imagesTabs">
                <TabPane label="个人镜像" name="private">
                    <List border>
                        <RadioGroup v-model="privateRadioId"  style="width:100%;" v-for="item in privateList.body">
                            <ListItem @click.native="selectEnv('private',item.id,item.name,item.img_origin)" style="cursor:pointer;">
                                <Radio :label="item.id">
                                    <span>{{item.name}}</span>
                                </Radio>
                            </ListItem>
                        </RadioGroup>
                    </List>
                </TabPane>
                <TabPane label="基础镜像" name="public">
                    <List border>
                        <RadioGroup v-model="publicRadioId"  style="width:100%;" v-for="item in commonList.body">
                            <ListItem @click.native="selectEnv('public',item.id,item.name,item.img_origin)" style="cursor:pointer;">
                                <Radio :label="item.id">
                                    <span>{{item.name}}</span>
                                </Radio>
                            </ListItem>
                        </RadioGroup>
                    </List>
                </TabPane>
            </Tabs>
        </Modal>
        <!--Lab环境结束-->

        <!-- 数据集-->
        <Modal
                v-model="showDataSet"
                title="选择数据集"
                width="700"
                @on-ok="confirmDataSet"
        >
            <p>

            <div style="padding-top:10px;min-height:300px;">
                <List>
                    <ListItem v-for="(value,key) in dataSetList" :key="key" @click.native="selectDataSetItem(value)" :class="{'active':value.show===true}" >
                        <ListItemMeta :title="value.name" :description="value.remark"/>
                        <template slot="action">
                            <li>
                                <span>{{value.create_user.name}}</span>
                            </li>
                        </template>
                    </ListItem>
                </List>
            </div>
            </p>
            <div slot="footer">
                <div class="footer-container">
                    <div style="width:73%;">
                        <div style="width:10%;">
                            <span style="float:left;">已选：</span>
                        </div>
                        <div style="width:90%">
                            <Tag closable v-for="item in TagList" size="medium" :name="item.id" @on-close="closeTag" style="float:left;">{{item.name}}</Tag>
                        </div>
                    </div>
                    <div style="width:25%;">
                        <Page :total="dataSetPage.count" :page-size="page_size" :page-num="page_num" @on-change="change_page" v-if="dataSetPage" simple />
                    </div>
                </div>
                <Button type="primary" @click="confirmDataSet">确认</Button>

            </div>
        </Modal>
        <!-- 数据集结束-->

    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {authApi} from '@/api/base.js'
    import cookie from "vue-cookies";

    // 引入富文本编辑器
    import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
    import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/zh-cn.js';
    import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight'
    import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
    import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
    import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
    import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
    import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
    import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
    import Code from '@ckeditor/ckeditor5-basic-styles/src/code';
    import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript';
    import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript';
    import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
    import Heading from '@ckeditor/ckeditor5-heading/src/heading';
    import Image from '@ckeditor/ckeditor5-image/src/image';
    import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
    import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
    import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
    import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
    import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
    import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';
    import Indent from '@ckeditor/ckeditor5-indent/src/indent';
    import Link from '@ckeditor/ckeditor5-link/src/link';
    import List from '@ckeditor/ckeditor5-list/src/list';
    import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
    import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
    import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
    import Table from '@ckeditor/ckeditor5-table/src/table';
    import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
    import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
    import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
    import Font from '@ckeditor/ckeditor5-font/src/font'
    import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
    import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
    import CodeBlock from '@ckeditor/ckeditor5-code-block/src/codeblock';
    import uploadComm from '@/components/upload/upload'
    // 引入结束
    export default {
        name: "addChapter",
        props:{
            chapter_id:Number,
            order:Number,
            mcpInfo:Object,
        },
        components:{
            uploadComm
        },
        data() {
            const validateImgDataSet = (rule,value,callback) =>{
                if(this.addForm.lab_type == 1 && this.addForm.image_id == 0 && this.addForm.image_origin == 0){
                    callback(new Error("请选择课程环境"));
                }else{
                    callback();
                }
            };
            return {
                maxSize:1024 * 300,
                ruleValidate:{
                    name:[
                        { required: true, message: '小节名称不能为空', trigger: 'change' }
                    ],
                    image_id:[
                        { validator: validateImgDataSet, trigger: 'blur' }
                    ]
                },
                page_num:1,
                page_size:6,
                // 镜像数据集相关
                currentImagesTabs:'private',
                imagesButtonName:"请选小节环境",
                publicRadioId:"",
                privateRadioId:"",
                showEnv:false,
                showDataSet:false,
                TagList:[],
                dataSetList:[],
                dataSetPage:{page_num:1,page_size:10,count:0},
                // end
                coursewareOptions1:[
                    {
                        id:1,
                        name:"Markdown"
                    },
                    {
                        id:5,
                        name:"富文本编辑器"
                    },
                    {
                        id:2,
                        name:"视频"
                    },
                    {
                        id:3,
                        name:"课件"
                    },
                    {
                        id:4,
                        name:"外链"
                    }
                ],
                uuid:"",
                baseUri:authApi,
                selTestPaperModel:false,
                access_token:cookie.get('session'),
                cur_subsecdata_idx:null,
                addForm: {
                    name: '',
                    lab_type: '0',
                    pan_name:'',
                    lab_link: '',
                    data:[],
                    image_id:0,
                    image_origin:0,
                    datasets_ids:[],
                },
                columns:[
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '试卷ID',
                        key: 'id',
                        sortable: true
                    },
                    {
                        title: '试卷名称',
                        key: 'name',
                    },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.showDetails(params.row)
                                        }
                                    }
                                }, '查看'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteRow(params)
                                        }
                                    }
                                }, '删除'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.copyRow(params.row)
                                        }
                                    }
                                }, '复制')
                            ]);
                        }
                    },
                ],
                datas:[],
                specialty:'',
                cwUploadUrl:'',
                cwUploadId:null,

                editor: ClassicEditor,
                editorConfig: {
                    plugins: [
                        Essentials,
                        Autoformat,
                        Bold,
                        Italic,
                        BlockQuote,
                        Heading,
                        Image,
                        ImageCaption,
                        ImageStyle,
                        ImageToolbar,
                        ImageUpload,
                        ImageResize,
                        Indent,
                        Link,
                        LinkImage,
                        // List,
                        MediaEmbed,
                        Paragraph,
                        PasteFromOffice,
                        Table,
                        TableToolbar,
                        TextTransformation,
                        CodeBlock,
                        Alignment,
                        Font,
                        Underline,
                        Strikethrough,
                        Code,
                        Subscript,
                        Superscript,
                        HorizontalLine,
                        Highlight,
                        // EasyImage
                        //Base64UploadAdapter,
                        SimpleUploadAdapter
                    ],
                    language: "zh-cn",
                    toolbar: {
                        items: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'link',
                            // 'bulletedList',
                            // 'numberedList',
                            '|',
                            'indent',
                            'outdent',
                            '|',
                            'linkImage',
                            'blockQuote',
                            // 'insertTable',
                            'mediaEmbed',
                            'undo',
                            'redo',
                            'Highlight',
                            'codeblock',
                            'Alignment',
                            'fontSize',
                            'fontFamily',
                            'fontColor',
                            'fontBackgroundColor',
                            'underline', 'strikethrough', 'code','subscript', 'superscript',
                            'horizontalLine',
                        ]
                    },
                    image:{
                        toolbar: [
                            'imageUpload',
                            'imageStyle:full',
                            'imageStyle:side',
                            '|',
                            'imageTextAlternative'
                        ]
                    },
                    simpleUpload:{
                        uploadUrl: '',
                        withCredentials: false,
                        headers: {
                            // 'X-CSRF-TOKEN': 'CSFR-Token',
                            // Authorization: 'Bearer jwt'
                        }
                    },
                    codeBlock: {
                        languages: [
                            // Do not render the CSS class for the plain text code blocks.
                            { language: 'plaintext', label: 'Plain text', class: '' },
                            // Use the "php-code" class for PHP code blocks.
                            { language: 'php', label: 'PHP', class: 'php-code' },
                            // Use the "js" class for JavaScript code blocks.
                            // Note that only the first ("js") class will determine the language of the block when loading data.
                            { language: 'javascript', label: 'JavaScript', class: 'js javascript js-code' },
                            // Python code blocks will have the default "language-python" CSS class.
                            { language: 'python', label: 'Python' }
                        ]
                    }
                }
            }
        },
        computed: {
            ...mapState({
                direction_info: state => state.courseManage.direction_info,
                lab_type_info:state => state.courseManage.lab_type_info,
                pri_wpans_info:state => state.priWpans.pri_wpans_info,
                user_info: state => state.loginState.user_info,

                privateList:state=>state.images.privateList,
                commonList:state=>state.images.publicList,
            })
        },
        methods: {
            ...mapActions({
                getChapterUuid:'common/get_uuid',
                getDirection: 'courseManage/getDirection',
                createSubsection:'courseManage/createSubsection',
                getLabType:'courseManage/getLabType',
                getPriWpan:'priWpans/getPriWpan',
                uploadPriwpan:'priWpans/uploadPriwpan',
                uploadWpanVideo:'priWpans/uploadWpanVideo',

                getPublicImagesList:'images/getPublicImagesList',
                getPrivateImagesList:'images/getPrivateImagesList',

                getDataSetList:'courseAdminDataSet/getDataSetList',
            }),
            currentIndexId(index){
                this.cur_subsecdata_idx=index
            },
            // uploadMaxSizeFunc(){
            //     this.$Message.error("文件大小超出限制,不能超过 "+this.maxSize / 1024+"M");
            // },
            changeLabType(){
                this.publicRadioId = "";
                this.privateRadioId = "";
                this.imagesButtonName = '请选择小节环境';
                this.addForm.image_id = 0;
                this.TagList = [];
                this.addForm.image_origin = 0;
                this.addForm.datasets_ids = [];
            },
            // 镜像数据集相关
            // 选择竞赛环境
            selectContestEnv(){
                this.showEnv = true;
                this.imagesTabs(this.currentImagesTabs);
            },
            selectEnv(type,radioId,envName,origin){
                switch (type) {
                    case 'private':
                        this.privateRadioId = radioId;
                        this.publicRadioId = '';

                        this.addForm.image_origin = origin;
                        this.addForm.image_id = radioId;

                        break;
                    case 'public':
                        this.publicRadioId = radioId;
                        this.privateRadioId = '';

                        this.addForm.image_origin = origin;
                        this.addForm.image_id = radioId;
                        break;
                }
                this.imagesButtonName = envName;
            },
            //环境切换
            imagesTabs(name){
                if(name == 'private'){
                    this.getPrivateImagesList({
                        data:{
                            mcp_type:this.mcpInfo.mcp_type,
                            channel:1,
                            status:3,
                            page_num:1,
                            page_size:1000
                        }
                    });
                }else{
                    this.getPublicImagesList({
                        data:{
                            mcp_type:this.mcpInfo.mcp_type,
                            channel:1,
                            page_num:1,
                            page_size:1000
                        }
                    });
                }
            },
            // 删除选中数据集触发
            closeTag(event, id){
                this.selectDataSetItem({id:id,title:""})
            },
            // 确认数据集后
            confirmDataSet(){
                this.addForm.data_set = this.TagList;
                this.showDataSet = false;
            },
            // 选择列表中的数据集
            selectDataSetItem(value){
                let isDel = false;
                let data = this.dataSetList.concat(this.dataSetList);
                this.TagList.forEach((item,index)=>{
                    if(item.id == value.id){
                        data.forEach((info)=>{
                            if (info.id == value.id){
                                info.show = false;
                            }
                        });
                        isDel = true;
                        this.TagList.splice(index,1);
                        this.addForm.datasets_ids.splice(index,1);
                    }
                });
                if(!isDel){
                    if(this.TagList.length >=3){
                        this.$Message.error("最多选择3个数据集");
                        return false;
                    }
                    value.show = true;
                    this.TagList.push({id:value.id,name:value.name})
                    this.addForm.datasets_ids.push(value.id)
                }
            },
            //数据集翻页
            change_page(page){
                this.page_num = page;
                this.selectDataSet();
            },
            // 选择数据集
            selectDataSet(){

                this.getDataSetList({
                    data:{
                        mcp_type:this.mcpInfo.mcp_type,
                        page_num:this.page_num,
                        page_size:this.page_size,
                    },
                    callback:(res,page)=>{
                        this.dataSetList = res;
                        this.dataSetPage = page;
                        // 判断已选中的数据
                        this.dataSetList.forEach((item,index)=>{
                            this.TagList.forEach((value)=>{
                                if(item.id === value.id){
                                    this.dataSetList[index].show = true;
                                }
                            })
                        });
                        this.showDataSet = true;
                    },
                    error:msg=>{
                        this.$Message.error(msg);
                    }
                });
            },
            //end
            panChange(val){
                if(val == '2'){
                    this.getPriWpan()
                }
            },
            // panClick(item){
            //     this.cwUploadUrl = `${item.schema}://${item.ip}/ilab.php?${item.upload_params}&name=${this.user_info.username}`
            //     this.cwUploadId = item.id
            // },
            cancel() {
                this.$parent.show_add_chapter = false
            },
            _delete(idx) {
                this.addForm.data.splice(idx, 1)
            },
            //添加附件
            addCourseware(){
                this.addForm.data.push({
                    data_id:null,
                    data_type:'',
                    filename:'',
                    introduction:'',
                    document:'',
                    link:''
                })
            },
            //上传视频成功
            videoSuccess(response,file){
                if (response.status.code == 2000000) {
                    this.addForm.data[this.cur_subsecdata_idx].data_id = response.body.subsecdata_id
                    this.addForm.data[this.cur_subsecdata_idx].filename = file.name
                }else{
                    this.$Message.error(response.status.message)
                }
            },
            //上传视频失败
            videoErr(response,file){
                console.log(response,file)
                this.$Message.error(file.message)
            },
            cwSuccess(response,file){
                if (response.status.code == 2000000) {
                    this.$Message.success(response.status.message)
                    this.addForm.data[this.cur_subsecdata_idx].data_id = response.body.subsecdata_id
                    this.addForm.data[this.cur_subsecdata_idx].filename = file.name
                }else{
                    this.$Message.error(response.status.message|| '上传失败！')
                }
            },
            // panVideoSuccess(response,file){
            //     let _this = this
            //     if (response.code == 200) {
            //         this.uploadWpanVideo({
            //             data:{
            //                 order:_this.cur_subsecdata_idx,
            //                 name:response.data.name,
            //                 size:response.data.size,
            //                 extension:response.data.extension,
            //                 link:response.data.link,
            //                 pri_wangpan_id:_this.cwUploadId
            //             },
            //             callback:res =>{
            //                 if(res.status.code === 2000000){
            //                     _this.$Message.success(res.status.message)
            //                     _this.addForm.data[_this.cur_subsecdata_idx].data_id = res.body.subsecdata_id
            //                     _this.addForm.data[_this.cur_subsecdata_idx].filename = file.name
            //                 }else{
            //                     _this.$Message.error(res.status.message)
            //                 }
            //
            //             }
            //         })
            //
            //     }else{
            //         this.$Message.error(response.msg || '上传失败！')
            //     }
            // },
            // panCwSuccess(response,file){
            //     let _this = this
            //     // response.data.size
            //     if (response.code == 200) {
            //         this.uploadPriwpan({
            //             data:{
            //                 order:_this.cur_subsecdata_idx,
            //                 name:response.data.name,
            //                 size:1,
            //                 extension:response.data.extension,
            //                 link:response.data.link,
            //                 pri_wangpan_id:_this.cwUploadId
            //             },
            //             callback:res =>{
            //                 if(res.status.code === 2000000){
            //                     _this.$Message.success(res.status.message)
            //                     _this.addForm.data[_this.cur_subsecdata_idx].data_id = res.body.subsecdata_id
            //                     _this.addForm.data[_this.cur_subsecdata_idx].filename = file.name
            //                 }else{
            //                     _this.$Message.error(res.status.message)
            //                 }
            //
            //             }
            //         })
            //
            //     }else{
            //         this.$Message.error(response.msg || '上传失败！')
            //     }
            // },
            //上传文档失败
            cwErr(response,file){
                this.$Message.error(file.message)
            },
            // videoFormatError(file){
            //     this.$Message.error('文件格式错误，请上传正确的视频格式文件！');
            // },
            // cwFormatError(){
            //     this.$Message.error('文件格式错误，请上传正确的格式文件！');
            // },
            confirm(){
                let _this = this;
                // 校验
                for(let i=0;i<this.addForm.data.length;i++){
                    if(this.addForm.data[i].data_type == "" || this.addForm.data[i].data_type == undefined){
                        this.$Message.error("相关课件类型必填");
                        return false;
                    }
                    if((this.addForm.data[i].data_type == 2 || this.addForm.data[i].data_type == 3) && this.addForm.data[i].filename==''){
                        this.$Message.error("请上传文件");
                        return false;
                    }
                    // 检查附件标题名称是否填写
                    if(this.addForm.data[i].introduction == ""){
                        this.$Message.error("请输入附件名称");
                        return false;
                    }
                }
                this.$refs["addForm"].validate((valid) => {
                    if (valid) {
                        this.createSubsection({
                            data:{
                                chapter_id:_this.chapter_id,
                                order:_this.order,
                                data:{
                                    lab_type: _this.addForm.lab_type,
                                    // lab_ids: _this.addForm.lab_ids,
                                    lab_link: _this.addForm.lab_link,
                                    uuid:_this.uuid,
                                    name:_this.addForm.name,
                                    // test_paper_ids:[],
                                    data:_this.addForm.data,
                                    image_origin:_this.addForm.image_origin,
                                    image_id:_this.addForm.image_id,
                                    datasets_ids:_this.addForm.datasets_ids,
                                }
                            },
                            callback:res =>{
                                if(res.status.code != 2000000){
                                    _this.$Message.error(res.status.message);
                                }else{
                                    _this.$parent.detailedCourse[_this.order].subsections.push({
                                        id:res.body.subsection_id,
                                        name:res.body.subsection_name,
                                        order:_this.$parent.detailedCourse[_this.order].subsections.length,
                                        data:_this.addForm.data
                                    })
                                    _this.$Message.success('添加小节成功！');
                                    _this.cancel()
                                }
                            },

                        })
                    }else{
                        this.$Message.error('请检查填写信息');
                    }
                });
            },
            getUuid(){
                let _this = this;
                this.getChapterUuid({
                    callback:res=>{
                        _this.uuid = res.uuid;
                        _this.editorConfig.simpleUpload.uploadUrl = _this.baseUri+"api-course/tm/course/chapter/subsection_pic?uuid="+_this.uuid+"&access_token="+_this.access_token;
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                });
            }
        },
        mounted() {
            this.getDirection();
            this.getLabType();
            // 获取随机uuid
            this.getUuid();
        },
    }
</script>

<style>
    .chapter-add .ck-content {
        min-height: 250px;
    }
</style>
<style scoped lang="less">
    @import "../../style/index";
    .active{
        position: relative;
        border: solid 1px #298dff;
    }
    .active:last-child{
        border: solid 1px #298dff;
    }
    .ivu-list-item{
        padding:16px 8px;
    }
    .active:after {
        content: "";
        right: 0;
        bottom: 0;
        width: 24px;
        height: 24px;
        position: absolute;
        background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTc2NTcxOTI1NjMwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExNTQ5IiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyMDAiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTEwMjQgMHYxMDI0SDB6IiBmaWxsPSIjMDA4MEZGIiBwLWlkPSIxMTU1MCI+PC9wYXRoPjxwYXRoIGQ9Ik02MjUuMjggODA2LjQ2NGEyMi4xNDQgMjIuMTQ0IDAgMCAxLTE1LjIzMi02LjE0NGwtMTE3Ljc2LTExMi43NjhhMjIuMDggMjIuMDggMCAxIDEgMzAuNTkyLTMxLjkzNmwxMDAuNDggOTYuMzIgMTgyLjQtMjIxLjYzMmEyMi4xNDQgMjIuMTQ0IDAgMCAxIDM0LjE3NiAyOC4xNmwtMTk3LjUwNCAyNDBhMjIuMTQ0IDIyLjE0NCAwIDAgMS0xNy4wODggOHoiIGZpbGw9IiNGRkZGRkYiIHAtaWQ9IjExNTUxIj48L3BhdGg+PC9zdmc+) 0/100% 100%;
        background-size: 100%
    }
    .courseware {
        padding: 10px;
        min-width: 561px;
        margin-bottom: 10px;
        background-color: #f7f7f7;

        .courseware-top {
            position: relative;

            .close {
                cursor: pointer;
                position: absolute;
                top: 6px;
                right: 10px;
            }
        }
    }
    .footer-container {
        padding-left: 18px;
        bottom: 0;
        height: 40px;
        width: 100%;
        line-height: 40px;
        font-size: 14px;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
    }
</style>
